import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6944dfe7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dvBodyTree" }
const _hoisted_2 = { class: "p-treenode-content" }
const _hoisted_3 = { class: "p-treenode-label" }
const _hoisted_4 = {
  key: 0,
  class: "p-treenode-badge"
}
const _hoisted_5 = {
  class: "p-treenode-content",
  style: {"margin-left":"-15px"}
}
const _hoisted_6 = { class: "p-treenode-icon" }
const _hoisted_7 = {
  class: "p-treenode-label",
  style: {"padding-left":"13px"}
}

import {useServicesFactoryStore} from '@/store/services-factory-store';
import Tree, { TreeNode } from 'primevue/tree';
import { PropType, computed, onMounted, onUnmounted, ref } from 'vue';
import {useMainStore} from '@/store/main-store';
import { ISesionApp } from '@/model/ISesionApp';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import Badge from 'primevue/badge';
import { Subscription} from "rxjs";
import {ChatService} from '@/services/ChatService';


export default /*#__PURE__*/_defineComponent({
  __name: 'menuBurger',
  props: {
 go: Boolean,
 menus: { type: Array as PropType<any>, required:true }
},
  emits: ['onClickMenu'],
  setup(__props, { emit: __emit }) {

const mainStore = useMainStore();
const sesion:ISesionApp|null = mainStore.getSesionApp;
const routeService = useServicesFactoryStore().getRouteService;
const uiManager = useServicesFactoryStore().getUIManager;
const chatService:ChatService = useServicesFactoryStore().getChatService;
const emit = __emit;
const NewMessagesTotal = ref<number>(0);
let NewMessagesTotalSubscription: Subscription;
const props = __props;
const isChatMenu = (m:any)=>
{
    return m && m.key === "3";
};
const menuFilter = computed(()=>
{
    const filteredMenus = new Array<any>();
    if(props.menus && props.menus.length > 0)
    {
        for (const menu of props.menus)
        {
            const m = validateMenu(menu);
            if(m)
            {
                filteredMenus.push(m);
            }
        }
    }
    return filteredMenus;
});
const validateMenu = (menu:any):any|null=>
{
    const newMenu = {...menu};
    let valido = false;
    if(newMenu.data && newMenu.data.inactivo) 
    {
        valido = false;
    }  
    else
    {
        valido = true;
        if(sesion.SyncData.IsEmpleado)
        {
            if(newMenu.data && newMenu.data.EmpresaId)
            {        
                let ids = new Array<any>();
                ids = newMenu.data.EmpresaId;
                if(ids.includes(sesion.SyncData.EmpresaEmpleadoId) )
                {
                    valido = true;
                }
            }   
            if(sesion.SyncData.IsEmpleado && newMenu.data && newMenu.data.menuNombre)
            {            
                valido = false;
                if (sesion.SyncData.PerfilMenu && sesion.SyncData.PerfilMenu.length > 0)
                {
                    const has = sesion.SyncData.PerfilMenu.find((x:any) => x.MenuNombre.toString().localeCompare(newMenu.data.menuNombre.toString()) === 0);               
                    if(has)
                        valido = true;
                }
                if(sesion.SyncData.IsRoot)
                {
                    valido = true;
                }                
            }
        } 
        if(newMenu.children)
        {
            const newChilds = new Array<any>();
            for (const child of newMenu.children)
            {   
                const c = validateMenu(child);
                if(c)
                {
                    newChilds.push(c);
                }
            }
            newMenu.children = newChilds;
        }  
    }
    return valido? newMenu:null;
}
const onNodeSelect= (node:TreeNode)=>
{    
    uiManager.ReloadCurrentAction = null;
    if(node &&  node.data && node.data.url)
    {
        if(props.go)
        {
            routeService.go(node.data.url);
        }
        uiManager.ActiveMenu.next(node);
        emit('onClickMenu',node);
    }
}
onMounted(async ()=>
{                   
   NewMessagesTotalSubscription = chatService.NewMessagesTotal.subscribe((total: any) => 
   {        
    NewMessagesTotal.value = total;
   }); 
});
onUnmounted(()=>
{
    if (NewMessagesTotalSubscription)
    {        
        NewMessagesTotalSubscription.unsubscribe();
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Tree), {
      value: menuFilter.value,
      selectionMode: "single",
      onNodeSelect: onNodeSelect
    }, {
      default: _withCtx((slotProps) => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t(`menus.menu_${slotProps.node.label}`)), 1),
          (isChatMenu(slotProps.node) && NewMessagesTotal.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                _createVNode(_unref(Badge), {
                  value: NewMessagesTotal.value > 100 ? '99+':NewMessagesTotal.value,
                  severity: "danger"
                }, null, 8, ["value"])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      fontawesome: _withCtx((slotProps) => [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, [
            _createVNode(_unref(FontAwesomeIcon), {
              icon: slotProps.node.icon.split(' ')
            }, null, 8, ["icon"])
          ]),
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t(`menus.menu_${slotProps.node.label}`)), 1)
        ])
      ]),
      _: 1
    }, 8, ["value"])
  ]))
}
}

})